export const NetworkContextName = 'NETWORK'